import { Link } from 'react-router-dom';
import SectionHeading from '@/components/feature/SectionHeading';
import NewsletterForm from '@/components/feature/NewsletterForm';
import { getLiveArticles, getCategoryName } from '@/utils/content';

export default function LiveFeedSection() {
  const live = getLiveArticles(6);

  return (
    <section id="live" className="scroll-mt-24 border-y border-background-200/70 bg-background-100/45">
      <div className="mx-auto w-full px-4 py-14 md:px-10 md:py-20">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1.6fr_1fr] lg:gap-14">
          <div>
            <SectionHeading
              kicker="LIVE FEED · 实时爆料流"
              title="从凌晨到现在，一条都没落下"
              description="按下时间顺序滚动，越靠上越新。带首发标识的条目为本站第一手内容。"
            />

            <ol className="relative ml-1.5 border-l border-background-300/60 pl-6">
              {live.map((item) => (
                <li key={item.id} className="group relative pb-8 last:pb-0">
                  <span className="absolute -left-[31px] top-1.5 flex h-3.5 w-3.5 items-center justify-center rounded-full border-2 border-background-50 bg-primary-500 transition-transform group-hover:scale-125"></span>
                  <div className="flex flex-wrap items-center gap-3">
                    <time className="font-heading text-base font-bold text-primary-400">
                      {item.liveTime}
                    </time>
                    <Link
                      to={`/category/${item.categorySlug}`}
                      className="rounded-full bg-secondary-500/15 px-2.5 py-0.5 text-xs text-secondary-300 transition-colors hover:bg-secondary-500/25"
                    >
                      {getCategoryName(item.categorySlug)}
                    </Link>
                    {item.isLive ? (
                      <span className="inline-flex items-center gap-1 text-xs text-accent-400">
                        <i className="ri-flashlight-fill"></i>
                        首发
                      </span>
                    ) : null}
                  </div>
                  <h3 className="mt-2 font-heading text-base font-semibold leading-snug text-foreground-100 transition-colors group-hover:text-primary-300 md:text-lg">
                    <Link to={`/article/${item.id}`}>{item.title}</Link>
                  </h3>
                  <p className="mt-1.5 line-clamp-2 text-sm leading-relaxed text-foreground-500">
                    {item.excerpt}
                  </p>
                  <div className="mt-2.5 flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-foreground-600">
                    <span className="inline-flex items-center gap-1">
                      <i className="ri-user-3-line"></i>
                      {item.author}
                    </span>
                    <span className="inline-flex items-center gap-1">
                      <i className="ri-timer-line"></i>
                      阅读约 {item.readTime}
                    </span>
                  </div>
                </li>
              ))}
            </ol>
          </div>

          <aside id="subscribe" className="scroll-mt-24 lg:sticky lg:top-28 lg:self-start">
            <div className="rounded-lg border border-background-200 bg-background-100 p-5 md:p-6">
              <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-500/15 text-primary-400">
                <i className="ri-notification-3-line text-xl"></i>
              </span>
              <h3 className="mt-4 font-heading text-lg font-bold text-foreground-50">
                首发先于热搜
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-500">
                留下邮箱，每当有新的第一手爆料发布，我们会把标题和链接直接推给你，不用一直刷新。
              </p>
              <div className="mt-5">
                <NewsletterForm />
              </div>
            </div>

            <div className="mt-4 rounded-lg border border-secondary-500/25 bg-secondary-500/5 p-5">
              <h3 className="flex items-center gap-2 font-heading text-sm font-semibold text-secondary-200">
                <i className="ri-shield-check-line"></i>
                我们的核实方式
              </h3>
              <ul className="mt-3 space-y-2.5 text-xs leading-relaxed text-foreground-500">
                <li className="flex gap-2">
                  <i className="ri-check-line mt-0.5 text-secondary-400"></i>
                  每条线索至少两位编辑独立比对信源
                </li>
                <li className="flex gap-2">
                  <i className="ri-check-line mt-0.5 text-secondary-400"></i>
                  公开材料优先，匿名线索需提供可验证细节
                </li>
                <li className="flex gap-2">
                  <i className="ri-check-line mt-0.5 text-secondary-400"></i>
                  后续信息冲突时在原文顶部挂更正说明
                </li>
              </ul>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}